const baseURL = 'https://zotpot.in/public/api/';

//Restaurants endpoint
export const Resturent_endpoint={
    GETRESTURENT_API:baseURL+"get-delivery-restaurants", 
    GETRESTURENT_CATEGORY_API:baseURL+"get-filtered-restaurants", 
}

//Slider endpoint
export const Slider_endpoint={
    SLIDER_API:baseURL+"promo-slider",   
}

//Category endpoint
export const Category_endpoint={
    CATEGORY_API:baseURL+"get-restaurant-category-slides",   
}

//Slug endpoint
export const Slug_endpoint={
    SLUG_API:baseURL+"get-restaurant-info",  
    SLUGITEM_API:baseURL+"get-restaurant-items",  
}

//Single Item endpoint
export const Single_Item_endpoint={
    SINGLE_ITEM_API:baseURL+"get-single-item", 
}

//Checkout endpoint
export const Checkout_endpoint={
    CHECKOUT_API:baseURL+"check-cart-items-availability", 
}

//register endpoint
export const Register_endpoint={
    REGISTER_API:baseURL+"register", 
}
//login endpoint
export const Login_endpoint={
    LOGIN_API:baseURL+"login", 
}
//User endpoint
export const GetProfile_endpoint={
    GETPROFILE_API:baseURL+"update-user-info", 
    GETPAGES_API:baseURL+"get-pages", 
    SAVEADDRESS_API:baseURL+"save-address",
    AVATURE_API:baseURL+"get-avatar",
    GETADDRESS_API:baseURL+"get-addresses",
    DELETEADDRESS_API:baseURL+"delete-address",
    MYORDER_API:baseURL+"get-orders",
}
//Add favorite endpoint
export const AddFavorite_endpoint={
    ADDFAVORITE_API:baseURL+"toggle-favorite",
    FAVORITE_API:baseURL+"get-favorite-stores", 
}

//Wallet endpoint
export const Wallet_endpoint={
    WALLET_API:baseURL+"get-wallet-transactions",
    COUPON_API:baseURL+"apply-coupon",
}

//payment endpoint
export const Payment_endpoint={
    PAYMENT_API:baseURL+"get-payment-gateways",
    PLACEORDER_API:baseURL+"place-order",
}

//order endpoint
export const Order_endpoint={
    CANCELORDER_API:baseURL+"cancel-order",
}

//set default address endpoint
export const defaultAddress_endpoint={
    DEFAULTADDRESS_API:baseURL+"set-default-address",
}